// services/school-ui/src/pages/chat/attachments/refRegistry.ts
//
// Per-process registry mapping a download_url back to its full
// AttachmentRef. Populated by ConversationAttachmentAdapter on
// successful upload; read by HttpAgentWithContext when assembling
// context.attachments for an AG-UI run.
//
// Why not React context: this lives outside the React tree (HttpAgent
// is constructed inside useMemo but processes events asynchronously
// from a callback the React tree doesn't reach). Module scope is the
// natural lifetime; entries trickle off as conversations are
// abandoned.

import type { AttachmentRef } from "./types";

const refs = new Map<string, AttachmentRef>();

export function registerRef(ref: AttachmentRef): void {
  refs.set(ref.download_url, ref);
}

export function lookupRef(downloadUrl: string): AttachmentRef | undefined {
  return refs.get(downloadUrl);
}

// Maps a composer chip's stable client id → the kernel attachment id.
// The adapter keeps the chip id stable across upload yields (changing it
// mid-generator makes assistant-ui render two chips — one stuck at
// "uploading 0%", one "ready"), so remove()/delete needs this side-lookup
// to reach the kernel-assigned id for the DELETE call.
const kernelIdByClientId = new Map<string, string>();

export function registerKernelId(clientId: string, kernelId: string): void {
  kernelIdByClientId.set(clientId, kernelId);
}

export function lookupKernelId(clientId: string): string | undefined {
  return kernelIdByClientId.get(clientId);
}

export function _resetRefsForTests(): void {
  refs.clear();
  kernelIdByClientId.clear();
}
